
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { useEffect, useState } from 'react';
import { SplashScreen } from '@drawbotics/react-drylus';
import { PropsTable, CodeBox } from '~/components/Playground';
export const Demo = () => {
  const [visible, toggle] = useState(false);
  useEffect(() => {
    const handlePressKey = e => {
      if (e.code === 'KeyS') {
        toggle(!visible);
      }
    };
    window.addEventListener('keydown', handlePressKey, false);
    return () => {
      window.removeEventListener('keydown', handlePressKey);
    };
  });
  if (visible) {
    return <SplashScreen text="Loading..." mdxType="SplashScreen" />;
  } else {
    return null;
  }
};

const layoutProps = {
  Demo
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Splash Screen`}</h1>
<p>{`This component will take over the entirety of the user screen, and display an animated loader.`}</p>
<p>{`Shown when a whole page should be loading and the user shouldn't perform any action. For example when the website is loading, or when an order is being placed.`}</p>
<PropsTable component={SplashScreen} mdxType="PropsTable" />
<h3>{`Demo`}</h3>
<p>{`Press `}<inlineCode parentName="p">{`s`}</inlineCode>{` on your keyboard to start the splash screen. Press it again to hide it.`}</p>
<CodeBox mdxType="CodeBox">
{`
  const [ visible, toggle ] = useState(false);
  useEffect(() => {
    const handlePressKey = (e) => {
      if (e.code === 'KeyS') {
        toggle(! visible);
      }
    };
    window.addEventListener('keydown', handlePressKey, false);
    return () => {
      window.removeEventListener('keydown', handlePressKey);
    };
  });
  if (visible) {
    return (
      <SplashScreen text="Loading..." />
    ); 
  }
  else {
    return null;
  }
`}
</CodeBox>

<Demo mdxType="Demo" />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;